<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;" v-if="only_view != true">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
          Log
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Log</a>
          </li>
      </ul>
    </div>
    <b-card v-if="show">
      <b-row v-if="only_view == true">
        <b-col class="title">
          Detect / Block Log
        </b-col>
      </b-row>
      <hr v-if="only_view == true">
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> Detect / Block Log
      </template> -->
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <!-- <b-form-group>
              <label for="opt_from"> Detected_at
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="reload()" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="reload()" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group> -->
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label for="opt_end"> To
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at_ed')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at_ed')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at_ed')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at_ed')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at_ed')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at_ed')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="reload()" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="reload()" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col> -->
        <!-- </b-row>
        <b-row> -->

        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_rule_id">Rule ID</label>
              <b-form-input placeholder="typing id of policy" @keydown.enter="reload()" type="text" id="opt_rule_id" v-model="so.opt['m_id']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_is_block">Action</label>
              <br>
              <select v-model="so.opt['is_block']" @change="reload()">
                <option value="">Please select Response</option>
                <option value="false">DetectionOnly</option>
                <option value="true">Block</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_method">Method</label>
              <br>
              <select v-model="so.opt['method']" @change="reload()">
                  <option value="">Select GET or POST</option>
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                </select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="4">
            <b-form-group>
              <label for="opt_rule_line">Rule Line</label>
              <b-form-input @keydown.enter="reload()" type="text" id="opt_rule_line" v-model="so.opt['m_line']"></b-form-input>
            </b-form-group>
          </b-col> -->
          <!-- <b-col md="4">
            <b-form-group>
              <label for="opt_rule_file">file</label>
              <b-form-input @keydown.enter="reload()" type="text" id="opt_rule_file" v-model="so.opt['m_file']"></b-form-input>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_headers">Header anything</label>
              <b-form-input placeholder="typing part of headers" @keydown.enter="reload()" type="text" id="opt_headers" v-model="so.opt['headers']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_uri">URI ( <b-checkbox v-model="so.opt.uri_check" inline>Exclude</b-checkbox>)</label>
              <b-form-input placeholder="typing part of URI" @keydown.enter="reload()" type="text" id="opt_uri" v-model="so.opt['uri']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_message">Message anything ( <b-checkbox v-model="so.opt.message_check" inline>Exclude</b-checkbox>)</label>
              <b-form-input placeholder="typing part of Message" @keydown.enter="reload()" type="text" id="opt_message" v-model="so.opt['message']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_attacker">Attacker ( <b-checkbox v-model="so.opt.remote_addr_check" inline>Exclude</b-checkbox>)</label>
              <b-form-input placeholder="typing part of Attacker" @keydown.enter="reload()" type="text" id="opt_attacker" v-model="so.opt['remote_addr']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_victim">Victim ( <b-checkbox v-model="so.opt.target_check" inline>Exclude</b-checkbox>) </label>
              <b-form-input placeholder="typing part of Victim" @keydown.enter="reload()" type="text" id="opt_victim" v-model="so.opt['target']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_xff">XFF ( <b-checkbox v-model="so.opt.xff_check" inline>Exclude</b-checkbox>) </label>
              <b-form-input placeholder="typing part of XFF" @keydown.enter="reload()" type="text" id="opt_xff" v-model="so.opt['xff']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="w-80">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <RuleCountry
                ref="_country"
                class="animated fadeIn fadeOut"
                :origin="country_code"
                :origin_use_geoip="use_geoip"
                :_show_block_only="true"
                :_show_toogle_button="false"
                :db_update_available="false"
                :hide_count="true"

                name="country_code"
                @update="($val, key) => country_code = $val"
                @use_geoip="($val, key) => use_geoip = $val"
              />
            </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="options && options.length" class="text-center">
          <b-col>
            Select custom showing data
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-checkbox-group
                v-model="selected"
                :options="options"
                button-variant="info"
                name="option"
                buttons
                style="color: #fff !important;"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="float-right">
              <b-button title="* Can search interval 6 months." v-b-tooltip.hover @click="download()" size="sm" variant="success" class="button-add">Export To csv</b-button>
              <b-button class="btn-add" size="sm" variant="success" @click="reload()"> Search </b-button>
              <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
              <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <!-- detail search end -->
      <b-row class="text-center">
        <b-col sm="3" md="3">
          Show count
          <select v-model="so.perPage" @change="refresh">
            <option value="10">Show count : Default 10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col sm="2" md="2">
        </b-col>
        <b-col>
          <span>Real-time</span>
          <c-switch class="pt-2 ml-2" color="success" label variant="pill" v-model="sync.run" @change="refresh" />
          <span v-b-tooltip.hover title="can see the log real-time" v-if="auto_refresh != false">
            <select v-model="sync.interval" @change="refresh" :disabled="!sync.run">
              <option value="15">Default interval : 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            Sec
          </span>
        </b-col>
        <b-col sm="3" md="3" v-if="only_view != true">
          <b-form-checkbox
            :title="`recommended to a minimum width of ${max_width}px`"
            v-b-tooltip.hover
            :disabled="!can_split_view"
            class="mt-2"
            v-model="is_half_mode"> Split view </b-form-checkbox>
        </b-col>
      </b-row>
      <hr v-if="only_view != true">
      <b-row v-if="only_view != true">
        <b-col>
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="reload()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='remote_addr';so.skt=`Attacker`">Attacker</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt=`Victim`">Victim</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='message';so.skt='Message'">Message</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='m_id';so.skt='Rule ID'">Rule ID</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='uri';so.skt='URI'">URI</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="reload()"></b-form-input>
            <b-input-group-append>
              <b-btn :disabled="so.adv" variant="outline-secondary" @click="reload()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> Detail Search</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr v-if="only_view != true">
      <b-row v-if="only_view != true" class="text-center">
        <b-col sm="1" md="1">
          <span>
            Agent Select
          </span>
        </b-col>
        <b-col>
          <multiselect deselect-label="Select to exclude from search" selected-label="Selected" @remove="reload" @select="reload" v-model="agent" tag-placeholder="Select agent nickname" placeholder="Select server" label="nickname" track-by="nickname" :options="agent_list" :multiple="true" :taggable="true" @tag="add_tag"></multiselect>
        </b-col>
        <b-col>
          <b-form inline>
            <span class="mr-2">Search Range</span>
            <date-picker v-if="i18n" @change="$refs._wc_log_list && $refs._wc_log_list.refresh()" v-model="so.created_at_sd" style="width: 140px;" :lang="custom.lang[i18n.toLowerCase()]" :confirm="false" :first-day-of-week="1"></date-picker>
            ~
            <date-picker v-if="i18n" @change="$refs._wc_log_list && $refs._wc_log_list.refresh()" v-model="so.created_at_ed" style="width: 140px;" :lang="custom.lang[i18n.toLowerCase()]" :confirm="false" :first-day-of-week="1"></date-picker>

            <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-1, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-1</b-button>
            <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-7, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-7</b-button>
            <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-30, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-30</b-button>
          </b-form>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col :sm="is_half_mode ? 6 : 12" :md="is_half_mode ? 6 : 12" :lg="is_half_mode ? 6 : 12" :xl="is_half_mode ? 6 : 12">
          <b-table hover striped small responsive="sm" foot-clone ref="_wc_log_list"
            class="table-responsive table_add"
            show-empty empty-text="not found"
            :items="getItems"
            :fields="fields"
            :current-page="so.currentPage" :per-page="so.perPage">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template slot="id" slot-scope="row"> {{startRow - row.index}}</template>
            <template slot="host" slot-scope="row">{{row.item.host || '-'}}</template>
            <template slot="castle" slot-scope="row">{{row.item.castle && row.item.castle.nickname ? row.item.castle.nickname : '-'}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="remote_addr" slot-scope="row">
              <span v-if="row.item.country" class="flag-icon" :class="set_flag(row.item.country)"></span>
              <span v-if="row.item.xff" class="ip">
                {{row.item.xff}}
              </span>
              <span v-else class="ip">
                {{row.item.remote_addr}}
              </span>
              <b-badge @click="info_xff = true" v-if="row.item.xff" variant='success' style='cursor: pointer;'>XFF (?)</b-badge>
            </template>
            <template slot="country" slot-scope="row">
              <span v-if="row.item.country">
                <span class="flag-icon" :class="set_flag(row.item.country)"></span>
                <span>({{ row.item.country }})</span>
              </span>
              <span v-else>
                -
              </span>
            </template>
            <template slot="target" slot-scope="row">{{row.item.target}}</template>
            <template slot="protocol" slot-scope="row">{{row.item.protocol}} {{row.item.method}}</template>
            <template slot="is_block" slot-scope="row">
              <b-badge v-if="row.item.is_block && row.item.block_cnt > 0" variant="danger">Block</b-badge>
              <b-badge v-else variant="warning">Detect</b-badge>
            </template>
            <template slot="message" slot-scope="row" >
              <strong v-if="row.item.is_failed">
                Parsering error, request to Support for checking
              </strong>
              <strong v-else>
                <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
                  {{row.item.summary && ruleI18n[row.item.summary.details.ruleId] ? ruleI18n[row.item.summary.details.ruleId]['EN'] : row.item.summary.message }}
                </a>
              </strong>
            </template>
            <template slot="severity" slot-scope="row">
              <span v-if="row.item.is_failed">
                -
              </span>
              <span v-else-if="row.item.message" class="font-weight-bold" style="display: inline-block">
                <div style="display: inline-flex">
                  <Bell v-if="row.item.message && row.item.message.messages.length > 1" :size="20" :count="row.item.message.messages.length" style="position: relative; top:-5px; left:-6px; z-index:100"/>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-if="row.item.summary.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 1"><b-badge variant="danger">Alert</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 2"><b-badge variant="danger">Critical</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 3"><b-badge variant="warning">Error</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 4"><b-badge variant="warning">Warning</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 5"><b-badge variant="info">Notice</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else-if="row.item.summary.details.severity == 6"><b-badge variant="info">Info</b-badge></span>
                  <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:-15px;' : 'position: relative;left:5px;'" v-else><b-badge variant="dark">Not recognized</b-badge></span>
                </div>
              </span>
              <span v-else>
                <span scope="row">
                  <b-button size="sm" :id="'tooltip_not_defined'+row.index" variant="outline-dark">
                    Not Defined
                  </b-button>
                  <b-tooltip :target="'tooltip_not_defined'+row.index" triggers="hover">
                    It could be a new attack, or it could not have been dispersed.
                  </b-tooltip>
                </span>
              </span>

            </template>

            <template slot="uri" slot-scope="row">{{autoSize() < row.item.uri.length ? row.item.uri.substring(0, autoSize()) + "..." : row.item.uri.substring(0, autoSize())}}</template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template>
          </b-table>
        </b-col>
        <b-col v-show="is_half_mode" :sm="is_half_mode ? 6 : 0" :md="is_half_mode ? 6 : 0" :lg="is_half_mode ? 6 : 0" :xl="is_half_mode ? 6 : 0">
          <Detail v-if="is_half_mode" :id="id"  ref="detail"/>
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="only_view != true">
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
    </b-card>
    <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-success" v-model="info_xff" hide-footer @ok="info_xff = false">
      One IP address of the client accessing the web server through HTTP proxy or load balancer.
    </b-modal>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
